import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld.vue'
import Page1 from '@/views/Page1.vue'
import Page2 from '@/views/Page2.vue'
import Page3 from '@/views/Page3.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [

    {
      path: '/',
      redirect: '/home'
    },
   
    {
      path: '/home',
      name: '首页',
      component: Page1
    },
    {
      path: '/online',
      name: '功能在线',
      component: Page2
    },
    {
      path: '/service',
      name: '服务支持',
      component: Page3
    }
  ]
})